export default __webpack_public_path__ + "static/media/Eye_3_M_C2.0b03c62e.svg";